// src/libs/tools/LazySpin.tsx
import React, { FC, ReactElement, ReactNode } from 'react';

interface LazySpinProps {
  children: ReactNode;
  fallback?: ReactElement;
}

/**
 * LazySpin is a wrapper around React.Suspense with a default fallback UI.
 * It shows a spinner while the children components are being lazy-loaded.
 *
 * @param children The content to render once it has loaded.
 * @param fallback The content to render while loading.
 */
const LazySpin: FC<LazySpinProps> = ({
  children,
  fallback = (
    <div role='status' aria-live='polite' aria-label='Loading...'>
      <span>Loading...</span>
    </div>
  ),
}) => {
  return <React.Suspense fallback={fallback}>{children}</React.Suspense>;
};

export default LazySpin;
